import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-674226fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Box-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "octicon octicon-x",
  viewBox: "0 0 12 16",
  version: "1.1",
  width: "12",
  height: "16",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48L7.48 8z"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "Box-title" }
const _hoisted_5 = { class: "overflow-auto" }
const _hoisted_6 = { class: "icon-viewer" }
const _hoisted_7 = { class: "d-flex flex-justify-center" }
const _hoisted_8 = { class: "material-icons py-3" }
const _hoisted_9 = { class: "Box-body overflow-auto" }
const _hoisted_10 = { class: "position-relative" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "octicon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.47 10.78a.75.75 0 001.06 0l3.75-3.75a.75.75 0 00-1.06-1.06L8.75 8.44V1.75a.75.75 0 00-1.5 0v6.69L4.78 5.97a.75.75 0 00-1.06 1.06l3.75 3.75zM3.75 13a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5z"
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "SVG", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "octicon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.47 10.78a.75.75 0 001.06 0l3.75-3.75a.75.75 0 00-1.06-1.06L8.75 8.44V1.75a.75.75 0 00-1.5 0v6.69L4.78 5.97a.75.75 0 00-1.06 1.06l3.75 3.75zM3.75 13a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5z"
  })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PNG", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "f6 text-bold text-uppercase text-gray" }, "Html:", -1))
const _hoisted_20 = { class: "position-relative" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "f6 text-bold text-uppercase text-gray" }, "React:", -1))
const _hoisted_22 = { class: "position-relative" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "f6 text-bold text-uppercase text-gray" }, "CSS:", -1))
const _hoisted_24 = { class: "position-relative" }
const _hoisted_25 = { class: "position-relative mt-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "f6 text-bold text-uppercase text-gray" }, "Codepoint:", -1))
const _hoisted_27 = { class: "position-relative" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "f6 text-bold text-uppercase text-gray" }, "Categories:", -1))
const _hoisted_30 = { class: "d-flex flex-wrap" }
const _hoisted_31 = { class: "Label ml-1 mt-1" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "f6 text-bold text-uppercase text-gray" }, "Tags:", -1))
const _hoisted_34 = { class: "d-flex flex-wrap" }
const _hoisted_35 = { class: "Label ml-1 mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Code = _resolveComponent("Code")!
  const _component_details_dialog = _resolveComponent("details-dialog")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "modal modal-overlay",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createElementVNode("div", {
          class: "modal-window",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(_component_details_dialog, { class: "Box Box--overlay d-flex flex-column anim-fade-in fast" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("button", {
                  class: "Box-btn-octicon btn-octicon float-right",
                  type: "button",
                  "aria-label": "Close dialog",
                  "data-close-dialog": "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, _hoisted_3),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.name), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("dl", null, [
                    _createElementVNode("dd", _hoisted_10, [
                      _createElementVNode("a", {
                        class: "btn btn-sm",
                        href: _ctx.svgAssetUrl,
                        role: "button",
                        "aria-label": "Download asset in SVG format for this icon",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.download(_ctx.svgAssetUrl)), ["prevent"]))
                      }, _hoisted_14, 8, _hoisted_11),
                      _createElementVNode("a", {
                        class: "btn btn-sm ml-2",
                        href: _ctx.pngAssetUrl,
                        role: "button",
                        "aria-label": "Download asset in PNG format for this icon",
                        download: ""
                      }, _hoisted_18, 8, _hoisted_15)
                    ])
                  ]),
                  _createElementVNode("dl", null, [
                    _hoisted_19,
                    _createElementVNode("dd", _hoisted_20, [
                      _createElementVNode("pre", null, [
                        _createElementVNode("code", null, _toDisplayString(_ctx.htmlCode()), 1)
                      ]),
                      _createVNode(_component_Code, {
                        code: _ctx.htmlCode()
                      }, null, 8, ["code"])
                    ])
                  ]),
                  _createElementVNode("dl", null, [
                    _hoisted_21,
                    _createElementVNode("dd", _hoisted_22, [
                      _createElementVNode("pre", null, [
                        _createElementVNode("code", null, _toDisplayString(_ctx.reactCode()), 1)
                      ]),
                      _createVNode(_component_Code, {
                        code: _ctx.reactCode()
                      }, null, 8, ["code"])
                    ])
                  ]),
                  _createElementVNode("dl", null, [
                    _hoisted_23,
                    _createElementVNode("dd", _hoisted_24, [
                      _createElementVNode("pre", null, [
                        _createElementVNode("code", null, _toDisplayString(_ctx.cssCode("before")), 1)
                      ]),
                      _createVNode(_component_Code, {
                        code: _ctx.cssCode('before')
                      }, null, 8, ["code"])
                    ]),
                    _createElementVNode("dd", _hoisted_25, [
                      _createElementVNode("pre", null, [
                        _createElementVNode("code", null, _toDisplayString(_ctx.cssCode("after")), 1)
                      ]),
                      _createVNode(_component_Code, {
                        code: _ctx.cssCode('after')
                      }, null, 8, ["code"])
                    ])
                  ]),
                  _createElementVNode("dl", null, [
                    _hoisted_26,
                    _createElementVNode("dd", _hoisted_27, [
                      _createElementVNode("pre", null, [
                        _createElementVNode("code", null, _toDisplayString(_ctx.codepoint), 1)
                      ]),
                      _createVNode(_component_Code, { code: _ctx.codepoint }, null, 8, ["code"])
                    ])
                  ]),
                  (_ctx.categories.length)
                    ? (_openBlock(), _createElementBlock("dl", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                            return (_openBlock(), _createElementBlock("dd", {
                              key: category,
                              class: "d-inline-flex"
                            }, [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(category), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tags.length)
                    ? (_openBlock(), _createElementBlock("dl", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("div", _hoisted_34, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                            return (_openBlock(), _createElementBlock("dd", {
                              key: tag,
                              class: "d-inline-flex"
                            }, [
                              _createElementVNode("span", _hoisted_35, _toDisplayString(tag), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}